import BillingIcon from '@/assets/icons/billing.svg?react'
import CreateNewIcon from '@/assets/icons/create-new.svg?react'
import DataListIcon from '@/assets/icons/data-list.svg?react'
import InstanceListIcon from '@/assets/icons/instance-list.svg?react'
import ProfileIcon from '@/assets/icons/profile.svg?react'
import SnapListIcon from '@/assets/icons/snapshot-list.svg?react'
import SpaceMgrIcon from '@/assets/icons/space-mgr.svg?react'

export const FeatItems = [
  { icon: CreateNewIcon, label: 'Deploy', value: 'create', href: '/create' },
  { icon: InstanceListIcon, label: 'My Deployments', value: 'instances', href: '/instances' },
  { icon: DataListIcon, label: 'Data Hub', value: 'data', href: '/data' },
  { icon: SnapListIcon, label: 'Snapshots', value: 'snapshots', href: '/snapshots' },
  { icon: SpaceMgrIcon, label: 'Storage Capacity', value: 'space', href: '/space' },
]

export const MenuItems = [
  { icon: BillingIcon, label: 'Usage', value: 'billing', href: '/billing' },
  { icon: ProfileIcon, label: 'My Account', value: 'profile', href: '/profile' },
]
